"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownContent = void 0;
var _react = _interopRequireWildcard(require("react"));
var _framerMotion = require("framer-motion");
require("./DropdownContent.css");
var _dropdown = require("@cbhq/cds-common/animation/dropdown");
var _zIndex = require("@cbhq/cds-common/tokens/zIndex");
var _VStack = require("../layout/VStack");
var _useMotionProps = require("../motion/useMotionProps");
var _linaria = require("../utils/linaria");
const _excluded = ["children", "value", "onOpen", "placement", "minWidth"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const dropdownStyleOverrides = "cds-dropdownStyleOverrides-dkby3k9";
const dropdownStaticClassName = 'cds-dropdown';
const MotionVStack = (0, _framerMotion.m)(_VStack.VStack);
const DropdownContent = /*#__PURE__*/(0, _react.memo)( /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let children = _ref.children,
    value = _ref.value,
    onOpen = _ref.onOpen,
    placement = _ref.placement,
    minWidth = _ref.minWidth,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isHorizontal = (placement === null || placement === void 0 ? void 0 : placement.includes('left')) || (placement === null || placement === void 0 ? void 0 : placement.includes('right'));
  const translate = isHorizontal ? 'x' : 'y';
  const motionProps = (0, _useMotionProps.useMotionProps)({
    enterConfigs: [_dropdown.animateDropdownOpacityInConfig, Object.assign({}, _dropdown.animateDropdownTransformInConfig, {
      property: translate
    })],
    exitConfigs: [_dropdown.animateDropdownOpacityOutConfig, Object.assign({}, _dropdown.animateDropdownTransformOutConfig, {
      property: translate
    })],
    exit: 'exit'
  });
  return /*#__PURE__*/_react.default.createElement(MotionVStack, _extends({
    ref: ref,
    background: true,
    borderRadius: "roundedLarge",
    className: (0, _linaria.cx)(dropdownStaticClassName, !minWidth ? dropdownStyleOverrides : undefined) // if there's a custom minWidth, we don't want to override that
    ,
    elevation: 2,
    minWidth: minWidth,
    overflow: "auto",
    role: "menu",
    tabIndex: 0,
    zIndex: _zIndex.zIndex.overlays.dropdown
  }, props, motionProps), children);
}));
exports.DropdownContent = DropdownContent;